import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import { getHiringCompanyAutosuggestJF } from 'app/services/partner/autosuggest';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

const HiringCompanyAutosuggestJF = autosuggestFactory({
   apiPromise: getHiringCompanyAutosuggestJF,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Hiring Company...',
});

export default withAutosuggestWrapper(withInputErrorMessage(HiringCompanyAutosuggestJF));
